import styles from './LpIntroduction.module.scss'

declare const hbspt: any
const LpIntroduction: React.FC = () => {
  return (
    <section className={styles.section} id="top">
      <img src="/images/LP/backend/FVPC.png" alt="TOP画面" className={styles.top_img_pc} />
      <img src="/images/LP/backend/FVSP.png" alt="TOP画面" className={styles.top_img_sp} />
      <div className={styles.text_panel}>
        <h1>
          AWS活用の大規模
          <br />
          システム開発サービス
        </h1>
        <img src="/images/LP/backend/top.png" alt="" />
        <p>
          AWS、GO、Node.jsなど、バックエンドの開発に特化した、
          <br />
          システム開発サービスです。
        </p>
      </div>
    </section>
  )
}

export default LpIntroduction
